import { inject, Injectable } from '@angular/core';
import { DEFAULT_MAX_RESULT_COUNT, ZnSelectQueryParams } from '@zendra/shared';
import { PropertyService } from 'cbd-proxies';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StandFusionCatalogs {
  private readonly propertyService = inject(PropertyService);

  loadPropertyOptions(
    params?: ZnSelectQueryParams,
  ): Observable<{ items: { key: string; value: string }[]; totalCount: number }> {
    return this.propertyService
      .getList({
        name: params?.search,
        locationIsActive: true,
        skipCount: params?.skipCount,
        maxResultCount: params?.maxResultCount ?? DEFAULT_MAX_RESULT_COUNT,
      })
      .pipe(
        map(response => ({
          items: response.items.map(item => ({
            key: String(item.id),
            value: item.name ?? String(item.id),
          })),
          totalCount: response.totalCount,
        })),
      );
  }
}
